import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import UzenetEditService from '../service/UzenetEditService';

const config = {
	key: 'uzenetEditForm',
	text: 'Üzenet',
	textKey: 'uzenet',
	service: UzenetEditService,
	icon: 'person',
	fields: [
		{
			key: 'kerdesSzoveg',
			text: 'Kérdés',
			textKey: 'kerdesSzoveg',
			component: EditFormTextField,
			multiline: true,
			readOnly: true
		},
		{
			key: 'mentValaszIn',
			text: 'Ment válasz?',
			textKey: 'mentValaszIn',
			component: EditFormSelectField,
			required: true,
			readOnly: true,
			items: [
				{
					id: 1,
					name: 'Igen'
				},
				{
					id: 0,
					name: 'Nem'
				}
			]
		},
		{
			key: 'tartalom',
			text: 'Tartalom',
			textKey: 'tartalom',
			component: EditFormTextField,
			required: true,
			readOnly: true,
			multiline: true
		},
		{
			key: 'tartalomValasz',
			text: 'Válasz',
			textKey: 'tartalomValasz',
			component: EditFormTextField,
			required: true,
			multiline: true
		}
	]
};

function UzenetEditForm() {
	return <EditFormPage config={config} />;
}

export default UzenetEditForm;
